import { Box, Chip } from '@mui/material';
import Typography from '@mui/material/Typography';

import {
  LogFwdSuccessIcon,
  SensorSuccessIcon,
  VMPSuccessIcon
} from '@/components/DeviceStatusIcon/DeviceCustomIcons';

import type { DeviceSyncRowProps } from '../SyncDevices.types';
import useStyles from '../SyncDevicesForm.styles';

const DeviceSyncRow = (props: DeviceSyncRowProps) => {
  const { host_name, device_type, action_type } = props;
  const { classes } = useStyles();
  return (
    <Box sx={{ WebkitBoxAlign: 'center', display: '-webkit-inline-box' }}>
      {device_type === 'lf' && <LogFwdSuccessIcon />}
      {device_type === 'ns' && <SensorSuccessIcon />}
      {device_type === 'vmp' && <VMPSuccessIcon />}

      <Typography style={{ paddingLeft: '.75rem' }}>{host_name}</Typography>

      {action_type === 'New' && (
        <Chip
          className={classes.deviceStatusChipAlign}
          variant="outlined"
          color="primary"
          size="small"
          label="New"
        />
      )}
      {action_type === 'Updated' && (
        <Chip
          className={classes.deviceStatusChipAlign}
          variant="outlined"
          color="warning"
          size="small"
          label="Updated"
        />
      )}
      {action_type === 'Deleted' && (
        <Chip
          className={classes.deviceStatusChipAlign}
          variant="outlined"
          color="error"
          size="small"
          label="Deleted"
        />
      )}
    </Box>
  );
};

export default DeviceSyncRow;
